export { default } from './withContentCards';
